import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ProjectCard from "./UserSearchPrefrence";
import chatify from "../../Assets/Projects/chatify.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
// import laptopImg from "../../Assets/about.svg";

function Search() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
        SimpleAdmin
        <strong className="purple"> Database </strong>
        </h1>
        <p style={{ color: "white" }}>
          Select what type of data you like to view!
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={true}
              title="Bans"
              description="View or search for bans in the SimpleAdmin database."
              ghLink="https://github.com/crywink/SimpleAdmin"
              moreInfo="https://discord.gg/mountain"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isSpeical={true}
              isBlog={false}
              title="Warnings"
              description="View or search for warnings in the SimpleAdmin database."
              moreInfo="https://discord.gg/mountain"
              specialDemo="https://mountaininteractive.com/resources/simple-admin-pro.6/"
              ghLink="https://github.com/crywink/SimpleAdmin"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog ={false}
              isAppeal={true}
              title="Appeals"
              description="Want to appeal a ban? Click here to appeal a ban."
              ghLink="https://discord.gg/mountain"
              moreInfo="https://discord.gg/mountain"
              specialDemo="https://discord.gg/mountain"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Search;
